import pre from './pre';
import post from './post';
import config from './config.vue';

export default {
  pre,
  components: {
    config,
  },
  post,
};
